import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import Page404 from 'pages/Page404';
import ErrorBoundary from 'components/ErrorBoundary';

const withErrorBoundary = (WrappedComponent) => (props) =>
  (
    <ErrorBoundary>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

// render - dashboard
const DashboardAnalytics = Loadable(withErrorBoundary(lazy(() => import('pages/dashboard/analytics'))));

// pages routing
const AuthLogin = Loadable(withErrorBoundary(lazy(() => import('pages/auth/login'))));
const AuthRegister = Loadable(withErrorBoundary(lazy(() => import('pages/auth/register'))));
const AuthForgotPassword = Loadable(withErrorBoundary(lazy(() => import('pages/auth/forgot-password'))));
const AuthResetPassword = Loadable(withErrorBoundary(lazy(() => import('pages/auth/reset-password'))));
const AuthCheckMail = Loadable(withErrorBoundary(lazy(() => import('pages/auth/check-mail'))));
const AuthCodeVerification = Loadable(withErrorBoundary(lazy(() => import('pages/auth/code-verification'))));

// Account

//render - servicepack
const ScoreCard = Loadable(withErrorBoundary(lazy(() => import('pages/scorecard/scorecard'))));
const Analytics = Loadable(withErrorBoundary(lazy(() => import('pages/analytics/analytics'))));
const Account = Loadable(withErrorBoundary(lazy(() => import('pages/account/account'))));
const Evaluation = Loadable(withErrorBoundary(lazy(() => import('pages/evaluation/evaluation'))));
const EvaluationPlayer = Loadable(withErrorBoundary(lazy(() => import('pages/evaluationPlayer'))));
const LiveCall = Loadable(withErrorBoundary(lazy(() => import('pages/livecall/livecall'))));
const Reporting = Loadable(withErrorBoundary(lazy(() => import('pages/reporting'))));
const Feedback = Loadable(withErrorBoundary(lazy(() => import('pages/feedback'))));
const Inspect = Loadable(withErrorBoundary(lazy(() => import('pages/inspect/inspect'))));
const InspectPlayer = Loadable(withErrorBoundary(lazy(() => import('pages/inspectPlayer'))));
const Settings = Loadable(withErrorBoundary(lazy(() => import('pages/setting/settings'))));
const Help = Loadable(withErrorBoundary(lazy(() => import('pages/help/help'))));
const Notification = Loadable(withErrorBoundary(lazy(() => import('pages/notification/notification'))));
const Logout = Loadable(withErrorBoundary(lazy(() => import('pages/logout/logout'))));
const DashboardManagement = Loadable(withErrorBoundary(lazy(() => import('pages/dashboardmanagement'))));

// ==============================|| MAIN ROUTING ||============================== //
const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'dashboard',
          element: <DashboardAnalytics />
        },
        //-------------------------new routes ******
        {
          path: 'account',
          element: <Account />
        },
        {
          path: 'scorecard',
          element: <ScoreCard />
        },
        {
          path: 'analytics',
          element: <Analytics />
        },
        {
          path: 'evaluation',
          element: <Evaluation />
        },
        {
          path: 'evaluation/:id',
          element: <EvaluationPlayer />
        },
        {
          path: 'inspect',
          element: <Inspect />
        },
        {
          path: 'inspect/:id',
          element: <InspectPlayer />
        },
        {
          path: 'livecall',
          element: <LiveCall />
        },
        {
          path: 'reporting',
          element: <Reporting />
        },
        {
          path: 'feedback',
          element: <Feedback />
        },
        {
          path: 'feedback/:id',
          element: <Feedback />
        },
        {
          path: 'settings',
          element: <Settings />
        },
        {
          path: 'help',
          element: <Help />
        },
        {
          path: 'notifications',
          element: <Notification />
        },
        {
          path: 'logout',
          element: <Logout />
        },
        {
          path: '404',
          element: <Page404 />
        }
        // {
        //   path: 'draganddrop',
        //   element: <DragAndDrop />
        // }
      ]
    },
    {
      path: '/auth',
      element: <CommonLayout />,
      children: [
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        }
      ]
    },
    {
      path: '/dashboardmanagement',
      element: (
        <AuthGuard>
          <DashboardManagement />
        </AuthGuard>
      )
    }
  ]
};

export default MainRoutes;
